export const ParseStrings = {

  bryntumDbDate: "YYYY-MM-DD",
  bryntumDbDateTime: "YYYY-MM-DDTHH:mm:ssZ",

}
